import jQuery from 'jquery';
import 'slick-carousel';
import svg4everybody from 'svg4everybody';
import { createApp } from 'vue';
import App from './components/App.vue';

window.$ = window.jQuery = jQuery;

createApp(App)
	.mount('#app');

(function () {
	svg4everybody();

	// Fixed header on scroll
	const $header = $('.header');
	let prevScrollTop = $(window).scrollTop();

	if (prevScrollTop > 10) {
		$header.addClass('scrolling');
	} else {
		$header.removeClass('scrolling');
	}

	$(window).on('scroll', function () {
		const currentScrollTop = $(window).scrollTop();

		if (currentScrollTop > 10) {
			$header.addClass('scrolling');

			if ($(window).width() > 1199) {
				if (prevScrollTop > currentScrollTop) {
					$header.removeClass('hidden-header');
				} else {
					$header.addClass('hidden-header');
				}
			}
		} else {
			$header.removeClass('scrolling');
			$header.removeClass('hidden-header');
		}

		prevScrollTop = currentScrollTop;
	});


	// Mobile menu
	$(document).on('click', '.header__menu-show, .header__menu-close', function (event) {
		event.preventDefault();

		$('#app').toggleClass('menu-shown');
	});


	// Show advantages list in product cards
	$(document).on('click', '.product-card', function (event) {
		event.preventDefault();

		const $this = $(this);
		const $button = $this.find('.toggle-button');
		const $toggle = $this.find('.product-card__advantages');

		$this.toggleClass('advantages-shown');

		if ($toggle.is(':hidden')) {
			$toggle.slideDown(function () {
				$button.find('.button-text').text($button.data('visible'));
			});
		} else {
			$toggle.slideUp(function () {
				$toggle.removeAttr('style');
				$button.find('.button-text').text($button.data('hidden'));
			});
		}

		$('html, body').stop().animate({
			'scrollTop': $this.offset().top
		}, 700, 'swing');
	});


	// Show advantages list in product cards
	$(document).on('click', '.readmore-button', function (event) {
		event.preventDefault();

		const $readmore = $(this).closest('.readmore');
		const $this = $(this);

		$readmore.toggleClass('readmore-shown');

		if ($readmore.hasClass('readmore-shown')) {
			$this.text($this.data('visible'));
		} else {
			$this.text($this.data('hidden'));
		}
	});

	// Scroll to
	$(document).on('click', '.scroll-to', function (event) {
		const animSpeed = 700;
		const $link = $(this);
		const hash = $link.attr('href').split('#')[1];
		const $target = $('#' + hash);

		if (!$target.length) {
			return;
		}

		event.preventDefault();

		if ($target.length > 0) {
			$('html, body').stop().animate({
				'scrollTop': $target.offset().top - 100
			}, animSpeed, 'swing', function () {
				// window.location.hash = hash;
				$('#app').removeClass('menu-shown');
			});
		}
	});


	// According
	$(document).on('click', '.accordion__button', function (event) {
		event.preventDefault();

		const $accordion = $(this).closest('.accordion');

		if (!$(this).hasClass('opened')) {
			$accordion.find('.accordion__hidden').slideUp();
			$accordion.find('.accordion__button').removeClass('opened');
			$(this).addClass('opened').next().slideDown();
		} else {
			$(this).removeClass('opened').next().slideUp();
		}

		return false;
	});

	// Year slider
	const centeringElement = function (element) {
		const screenWidth = $(window).width();
		const firstItem = element.is(':first-child');
		let activeWidth;

		if (screenWidth > 768) {
			if (firstItem) {
				activeWidth = (element.width()) / 2;
			} else {
				activeWidth = (element.width() + 52) / 2;
			}
		} else {
			if (firstItem) {
				activeWidth = (element.width() - 210) / 2;
			} else {
				activeWidth = (element.width() + 40 - 170) / 2;
			}
		}

		const activePosition = element.position().left + activeWidth;
		const leftScroll = $yearSliderNav.scrollLeft();
		const navWidth = $yearSliderNav.width();
		const currentPosition = activePosition + leftScroll - navWidth / 2;

		$yearSliderNav.scrollLeft(currentPosition);
	};

	const $yearSliderNav = $('#year-slider-nav');
	const $yearSlider = $('#year-slider').slick({
		arrows: false,
		adaptiveHeight: true
	});

	$yearSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$yearSliderNav.find('li').removeClass('slick-current');
		$yearSliderNav.find('li').eq(nextSlide).addClass('slick-current');
		centeringElement($yearSliderNav.find('li').eq(nextSlide));
	});

	$(document).on('click', '#year-slider-nav li', function (event) {
		event.preventDefault();

		$yearSlider.slick('slickGoTo', $(this).index());

		$yearSliderNav.find('li').removeClass('slick-current');
		$(this).addClass('slick-current');

		centeringElement($(this));
	});

	// Contact us tabs
	$('ul.contact-us__switcher-tabs').on('click', 'li:not(.active)', function () {
		$(this)
			.addClass('active')
			.siblings()
			.removeClass('active')
			.closest('.contact-us__switcher')
			.find('.contact-us__switcher-content')
			.removeClass('active')
			.eq($(this).index())
			.addClass('active');
	});

	// Footer
	$(document).on('click', '.toggle-useful', function (event) {
		event.preventDefault();

		const $footer = $(this).closest('.footer');

		$footer.toggleClass('useful-shown');
		$footer.find('.footer__hidden').slideToggle(function () {
			if ($footer.hasClass('useful-shown')) {
				$('html, body').stop().animate({
					'scrollTop': $('#useful').offset().top
				}, 700, 'swing');
			}
		});
	});

	$(document).on('submit', '#contactForm', function (e) {
		e.preventDefault();

		const $form = $(e.target);
		const data = $form.serialize();

		$form.find('input, button, textarea').attr('disabled', 'disabled');

		$.ajax({
			url: '/',
			method: 'POST',
			dataType: 'json',
			data: data
		})
			.done((response) => {
				if (response.success) {
					$form.slideUp(() => $form.remove());
					$('#contactFormSuccess').slideDown();
				} else {
					$form.find('input, button, textarea').removeAttr('disabled');
					console.warn(response);
				}
			})
			.fail(() => {
				$form.find('input, button').removeAttr('disabled');
			});
	});

	// Testimonials
	$('.testimonials-carousel').slick({
		autoplaySpeed: 5000,
		autoplay: true,
		arrows: false,
		dots: true
	});

	$(document).on('click', function (event) {
		const $parentDropdown = $(event.target).parents('[data-has-dropdown]');
		if (!$parentDropdown.length) {
			$('.dropdown-shown').removeClass('dropdown-shown');
		}
	});

	$(document).on('click', '[data-toggle-dropdown]', function (event) {
		event.preventDefault();
		$(this).parent().toggleClass('dropdown-shown');
	});

	$(document).on('click', '[data-close-dropdown]', function (event) {
		event.preventDefault();
		$(this).parent().parent().parent().removeClass('dropdown-shown');
	});

	/**
	 * Image sliders
	 ************************************************************************/

	$('[data-slides]').slick({
		arrows: true,
		dots: true
	});
})();